<template>
  <div v-if="loading" class="home">
    <div class="home-menu">
      <div
        v-for="item in menuList"
        :key="item.name"
        :class="['home-menu-item', isActive(item.nameList) && 'menu-active']"
        @click="changeMenu(item.name)"
      >
        <div class="home-menu-item-left">
          <img :src="isActive(item.nameList) ? item.activeIcon : item.icon" />
          <span>{{ item.text }}</span>
        </div>
        <div class="home-menu-item-right">
          <i class="icon iconfont icon-right"></i>
        </div>
      </div>
    </div>
    <div class="home-content">
      <div :class="routeName === 'OverallStat' && 'postion-box'">
        <SelectRegionId
          v-model="regionId"
          @changeAreaId="changeAreaId"
          @changeTimes="changeTimes"
          :needShare="routeName === 'OverallStat'"
          v-show="showCom"
        />
      </div>
      <keep-alive :include="cacheComs">
        <router-view
          :key="fullPath"
          :regionId="regionId"
          :areaId="areaId"
          :filterTimes="filterTimes"
        ></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectRegionId from '../common/SelectRegionId'

export default {
  name: 'Home',
  components: {
    SelectRegionId,
  },
  data() {
    return {
      regionId: '',
      areaId: '',
      filterTimes: {},
      loading: false,
      needRegionSelects: ['OverallStat', 'School', 'Org'],
      cacheComs: ['OverallStat', 'School', 'ActivationCode', 'Org'],
      menuList: [
        {
          name: 'OverallStat',
          text: '总览',
          icon: require('@/assets/icon/overall-stat.png'),
          activeIcon: require('@/assets/icon/overall-stat-active.png'),
          nameList: ['OverallStat'],
        },
        {
          name: 'School',
          text: '学校',
          icon: require('@/assets/icon/school.png'),
          activeIcon: require('@/assets/icon/school-active.png'),
          nameList: ['School', 'SchoolDetail'],
        },
        {
          name: 'Org',
          text: '机构',
          icon: require('@/assets/icon/school.png'),
          activeIcon: require('@/assets/icon/school-active.png'),
          nameList: ['Org'],
        },
        {
          name: 'ActivationCode',
          text: '激活码',
          icon: require('@/assets/icon/activation-code.png'),
          activeIcon: require('@/assets/icon/activation-code-active.png'),
          nameList: ['ActivationCode', 'ActivationCodeDetail'],
        },
        {
          name: 'PayDetail',
          text: '付费详情',
          icon: require('@/assets/icon/pay.png'),
          activeIcon: require('@/assets/icon/pay-active.png'),
          nameList: ['PayDetail'],
        },
        {
          name: 'CourseDetail',
          text: '课程详情',
          icon: require('@/assets/icon/pay.png'),
          activeIcon: require('@/assets/icon/pay-active.png'),
          nameList: ['CourseDetail'],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      userDetail: 'customer/userDetail',
    }),
    routeName() {
      return this.$route.name || 'OverallStat'
    },
    fullPath() {
      return this.$route.fullPath
    },
    showCom() {
      return this.needRegionSelects.includes(this.routeName)
    },
  },
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions({
      changeUserDetail: 'customer/changeUserDetail',
    }),
    async init() {
      this.loading = false
      await this.changeUserDetail()
      const { agentRegions = [] } = this.userDetail
      if (agentRegions.length === 0) {
        this.$router.push({
          name: 'ContactCustomer',
        })
        return
      }
      this.loading = true
    },
    isActive(nameList) {
      return nameList.includes(this.routeName)
    },
    changeMenu(name) {
      if (name !== this.routeName) {
        this.$router.push({
          name,
        })
      }
    },
    changeAreaId(areaId) {
      this.areaId = areaId
    },
    changeTimes(params) {
      this.filterTimes = params
    },
  },
}
</script>

<style lang='scss'>
.home {
  display: flex;
  min-height: 1080px;
  .home-menu {
    width: 18%;
    background: #fff;
    box-shadow: 6px 6px 4px 0px rgba(92, 92, 93, 0.1);
    .home-menu-item {
      width: 100%;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 10%;
      color: #b8bec3;
      font-size: 16px;
      cursor: pointer;
      .home-menu-item-left {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 22px;
          margin-right: 6px;
        }
      }
    }
    .menu-active {
      color: #ffffff;
      background-image: linear-gradient(
          0deg,
          rgba(0, 125, 255, 0.99) 0%,
          rgba(0, 172, 255, 0.99) 100%
        ),
        linear-gradient(#1890ff, #1890ff);
    }
  }
  .home-content {
    width: 77.4%;
    margin: 1.8% 2.3%;
    position: relative;
    .postion-box {
      position: absolute;
      left: 0px;
      top: 0px;
      right: 0px;
      margin: 0 auto;
    }
  }
}
</style>